package repositories

import practicetest.MaterialsResponse

class MaterialRepositoryException(val isNetwork: Boolean) : Exception()


interface MaterialRepository {
    suspend fun fetchMaterials(subject: String, topic: String): Result<MaterialsResponse>
}